export * from './ProductDetailsLabel';
